import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.08 2.86a5.25 5.25 0 0 0-5.867 7.3.75.75 0 0 1-.153.84l-6.91 6.91a1.371 1.371 0 0 0 1.94 1.94L13 12.94a.75.75 0 0 1 .84-.153 5.25 5.25 0 0 0 7.3-5.867l-2.915 2.916a1.75 1.75 0 0 1-2.45 0l-.005-.006-1.606-1.605a1.75 1.75 0 0 1 0-2.45l.006-.005zm-2.294-1.504a6.75 6.75 0 0 1 3.993.49A.75.75 0 0 1 19 3.06l-3.766 3.767a.25.25 0 0 0 0 .346l1.593 1.593a.25.25 0 0 0 .346 0L20.94 5a.75.75 0 0 1 1.213.22 6.75 6.75 0 0 1-8.444 9.132L7.15 20.91a2.871 2.871 0 1 1-4.06-4.06l6.558-6.559a6.75 6.75 0 0 1 5.138-8.935",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }